import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./PlayerVolume.css";
import PropTypes from "prop-types";
import Slider from "@material-ui/core/Slider";
import VolumeDown from "@material-ui/icons/VolumeDown";
import VolumeUp from "@material-ui/icons/VolumeUp";
import { setVolume, muteAudio, unmuteAudio } from "redux/actions/PlayerActions";
import VolumeMuteIcon from "@material-ui/icons/VolumeMute";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import IconButton from "@material-ui/core/IconButton";
import { getPlayerVolume } from "util/CommonFunc";

class Player extends Component {
  constructor() {
    super();
    this.state = {
      playerVolume: 100
    };
  }

  componentDidMount() {
    const volume = getPlayerVolume();
    this.setState({ playerVolume: volume });
  }

  render() {
    const {
      classes,
      player: { isMute },
      setVolume,
      muteAudio,
      unmuteAudio,
    } = this.props;
    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            {isMute ? (
              <IconButton title={t("player.muteButton")} onClick={() => unmuteAudio()}>
                <VolumeOffIcon />
              </IconButton>
            ) : (
              <>
                {this.state.playerVolume === 0 ? (
                  <IconButton title={t("player.volume") + ": " + this.state.playerVolume + "%"} onClick={() => muteAudio()}>
                    <VolumeMuteIcon />
                  </IconButton>
                ) : this.state.playerVolume < 50 ? (
                  <IconButton title={t("player.volume") + ": " + this.state.playerVolume + "%"} onClick={() => muteAudio()}>
                    <VolumeDown />
                  </IconButton>
                ) : (
                  <IconButton title={t("player.volume") + ": " + this.state.playerVolume + "%"} onClick={() => muteAudio()}>
                    <VolumeUp />
                  </IconButton>
                )}
              </>
            )}
            <Slider
              title={t("player.volume") + ": " + this.state.playerVolume + "%"}
              className={classes.volumeSlider}
              value={this.state.playerVolume}
              onChange={(event, volume) => { this.setState({ playerVolume: volume }); setTimeout(() => setVolume(volume), 0); }}
            />
          </>
        )}
      </Translation>
    );
  }
}

Player.propTypes = {
  player: PropTypes.object.isRequired,
  setVolume: PropTypes.func.isRequired,
  muteAudio: PropTypes.func.isRequired,
  unmuteAudio: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVolume: (payload) => dispatch(setVolume(payload)),
    muteAudio: () => dispatch(muteAudio()),
    unmuteAudio: () => dispatch(unmuteAudio()),
  };
};

const mapStateToProps = (state) => ({
  player: state.player,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Player));
